import { useCallback, useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { useDropzone } from "react-dropzone"


import { useRequestProcessor } from "../../api/requestProcessor"
import { uploadImage } from "../../api/upload-files"
import { storeSingleBlogs } from "../../api/blogs"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import Select from "react-select"
import makeAnimated from 'react-select/animated';
import { getAllCategoriesWithType } from "../../api/categories"


const CreateBlogs = () => {

    const [name, setName] = useState("")
    const [selectedCategory, setSelectedCategory] = useState([])
    const [thumb, setThumb] = useState()
    const [thumbBlob, setThumbBlob] = useState()

    const [blogPicture, setBlogPicture] = useState()
    const [blogPictureBlob, setBlogPictureBlob] = useState()

    const [description, setDescription] = useState("")
    const [convertedContent, setConvertedContent] = useState(null);


    const navigate = useNavigate()
    const { Query, Mutate } = useRequestProcessor()


    function onDescriptionHandler(event) {
        setDescription(event.target.value)
    }


    const { data: categoryData, isLoading: discountLoading, refetch } = Query(
        ['getAllCategoryByType', "blogs"],
        () => getAllCategoriesWithType("blogs")
    );

    //  react query req

    const { mutate: storeBlogData } = Mutate(
        "storeBlog",
        storeSingleBlogs,
        {
            onSuccess: (data) => {
                toast.success(data.message + " تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید")
                setTimeout(() => { navigate("/admin/blogs") }, 3000)
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );


    const { mutate } = Mutate(
        "uploadImage",
        uploadImage,
        {
            onSuccess: (data) => {
                successfulHandler(data) //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );


    const { mutate: blogImageMutate } = Mutate(
        "uploadImage",
        uploadImage,
        {
            onSuccess: (data) => {
                successfulBlogImageHandler(data) //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );


    const onDrop = useCallback(acceptedFiles => {
        setBlogPictureBlob(URL.createObjectURL(acceptedFiles[0]))
        let formData = new FormData();
        formData.append("images", acceptedFiles[0])
        blogImageMutate(formData)
    }, [])


    const onDropThumb = useCallback(acceptedFiles => {
        setThumbBlob(URL.createObjectURL(acceptedFiles[0]))
        let formData = new FormData();
        formData.append("images", acceptedFiles[0])
        mutate(formData)
    }, [])




    // DROPZONE CONFIG

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop, accept: {
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
        }
    })
    const { getRootProps: getThumbRootprops, getInputProps: getThumbInputProps, isDragActive: isThumbDragActive } = useDropzone({
        onDrop: onDropThumb, accept: {
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
        }
    })




    function successfulHandler(res) {
        toast.success("فایل با موفقیت آپلود شد.")
        setThumb(res.images.thumb);
    }
    function successfulBlogImageHandler(res) {
        toast.success("فایل با موفقیت آپلود شد.")
        setBlogPicture(res.images.thumb);
    }

    async function onSubmitHandler(e) {
        e.preventDefault();
        let data = {
            title: name,
            description: description,
            body: convertedContent,
            category_id: selectedCategory?.map(el => el.value),
            cover_image: {
                thumb: thumb
            },
            blog_images: {
                thumb: blogPicture
            },

        }

        storeBlogData(data);
        // await storeSingleCategories(data).then(res => res.message === "دسته بندی با موفقیت ساخته شد." ? successfulHandler(res) : errorHandler(res.errors))
    };

    const animatedComponents = makeAnimated();
    function handleOnChange(data) {
        setSelectedCategory(data)
    }
    return (
        <Layout >
            <MainPageLayout backButton sectionTitle={"مشخصات بلاگ :"} title={"ایجاد بلاگ جدید"} >
                <form onSubmit={onSubmitHandler}>
                    <div className="flex">
                        <div className='flex flex-col mb-4 w-full'>
                            <div className='flex flex-col mb-3'>
                                <p className='pr-3 pb-1'>نام بلاگ :</p>
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} className=' form-input !w-full' placeholder='نام بلاگ' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>توضیح بلاگ:</p>
                                <div className='flex form-input !w-full items-center '>
                                    <input value={description} onChange={onDescriptionHandler} type="text" className='form-input !w-full' placeholder='توضیح مختصر درباره بلاگ ' />
                                    <div className={`flex basis-1/4 justify-center border ${description.length > 180 ? "!bg-red-500 text-white" : "text-green-500"} border-black rounded-xl py-2 mr-2 bg-white`}>180 / {description.length} </div>
                                </div>
                            </div>

                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>انتخاب دسته بندی :</p>
                                <Select components={animatedComponents} placeholder="انتخاب کنید..."
                                    onChange={handleOnChange} closeMenuOnSelect={false}
                                    isMulti options={categoryData?.data?.map(el => ({ label: el.title, value: el.id }))}

                                />
                            </div>
                        </div>
                        <div className="w-full flex flex-col mr-4">

                            <div className="flex flex-col mb-4">
                                <p className='pr-3 pb-1'>انتخاب عکس بنر :</p>

                                <form id='recommendationDiv' className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getThumbRootprops()}>
                                    <input
                                        {...getThumbInputProps()} />
                                    {
                                        <p> فایل را انتخاب یا به اینجا بکشید</p>
                                    }
                                </form>
                                <div className="flex justify-center my-2">
                                    <img src={thumbBlob} className="w-[150px]" alt="" />
                                </div>
                            </div>
                            <div className="flex flex-col mb-4">
                                <p className='pr-3 pb-1'>انتخاب عکس بلاگ :</p>

                                <form id='recommendationDiv' className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getRootProps()}>
                                    <input
                                        {...getInputProps()} />
                                    {
                                        <p> فایل را انتخاب یا به اینجا بکشید</p>
                                    }
                                </form>
                                <div className="flex justify-center my-2">
                                    <img src={blogPictureBlob} className="w-[150px]" alt="" />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="flex flex-col my-3">
                        <p className='pr-3 pb-1'>متن بلاگ :</p>
                        <CKEditor
                            editor={ClassicEditor}
                            data={convertedContent ?? ""}
                            config={{
                                language: {
                                    ui: "en",
                                    content: "ar"
                                }
                            }}
                            onReady={editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setConvertedContent(data);
                            }}

                        />
                    </div>
                    <p className='pr-3 text-sm'>متاتگ های وبسایت بر اساس کلمات نوشته شما ساخته میشود</p>

                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default CreateBlogs